<template lang="pug">
	modal(:max-width="800")
		.card.text-left
			.card-header
				span.fa.fa-search.mr-2
				| Selección de originales
				button.close(@click="cerrar") &times;
			.contenedor
				.formulario
					div(style="margin: 10px;")
						b Fecha de vigencia
						vc-date-picker(
							is-expanded
							:rows="2"
							:columns="2"
							mode="range"
							v-model="filtro.fechas"
							:input-props=`{
								class: "form-control",
								readonly: true
							}`
						)
						.form-group.mt-2
							label
								b Cliente
							input-query(
								v-if="!filtro.ClienteID"
								placeholder="Busca cliente"
								:realtime="true"
								input-class="form-control form-control-sm"
								url="mis-contratos/php/api/buscaCliente.php"
								@selected="setCliente($event)"
							)
							div.input-group(v-else)
								input.form-control.form-control-sm(:value="ClienteNombre", :disabled="true")
								.input-group-append
									button.btn.btn-sm.btn-danger(@click="delCliente")
										span.fa.fa-trash
						.form-group.mt-2
							label
								b Título de campaña o fichero
							input.form-control.form-control-sm(v-model="filtro.Titulo", @keypress.enter="getFicheros()")
					
					button.btn-block.btn-primary(@click="getFicheros")
						span.fa.fa-search.mr-2
						| Buscar
				.listado
					div.bg-dark.text-white.p-1.pl-3
						span.fa.fa-list.mr-2
						b Resultados
					table.table.table-striped.m-0
						tbody
							tr(
								v-for="fichero in ficheros"
								:key="fichero.FicheroID"
								@click="toggle(fichero)"
								:class="seleccionado.indexOf(fichero) >= 0 ? 'bg-warning' : ''"
							)
								td.pl-3
									.nombreFichero
										span {{fichero.FicheroID}} - {{fichero.Nombre}}
								td.text-right
										span.ml-2(style="opacity: 0.4;") {{fichero.FicheroDuracion | round}} s.
			.card-footer.text-right
				button.btn.btn-sm.btn-primary(@click="seleccionar", :disabled="!seleccionado")
					span.fa.fa-check.mr-2
					| Seleccionar
</template>

<script>
import Services from '../../../servicios'
export default {
	props: ['AnuncianteID', 'ClienteID', 'solo'],
	data () {
		return {
			filtro: {
				fechas: {
					start: this.$moment().subtract(1, 'year').toDate(),
					end: new Date()
				},
				ClienteID: null,
				Titulo: null
			},
			ClienteNombre: null,
			ficheros: [],
			seleccionado: []
		}
	},
	created () {
		if (this.ClienteID) {
			this.filtro.ClienteID = parseInt(this.ClienteID)
		}
		this.getFicheros()
		this.getCliente()
	},
	methods: {
		getCliente () {
			this.$http.get('gestion-clientes/php/api/get-cliente.php?ID=' + this.ClienteID)
				.then(res => {
					this.ClienteNombre = res.data.cliente.cliente
				})
				.catch(e => {
					console.error(e)
					this.$responseError(e)
				})
		},
		toggle (fichero) {
			if (this.solo) {
				this.seleccionado = []
			}
			for (let i = 0; i < this.seleccionado.length; i++) {
				if (this.seleccionado[i] === fichero) {
					this.seleccionado.splice(i, 1)
					return
				}
			}

			this.seleccionado.push(fichero)
		},
		getFicheros () {
			const form = {
				ClienteID: this.filtro.ClienteID,
				FechaDesde: this.$moment(this.filtro.fechas.start).format('YYYY-MM-DD'),
				FechaHasta: this.$moment(this.filtro.fechas.end).format('YYYY-MM-DD'),
				Cadena: this.filtro.Titulo
			}
			Services.GetOriginales(form)
				.then(ficheros => {
					this.ficheros = ficheros
				})
				.catch(e => {
					console.log(e)
					this.$error('Error', e)
				})
		},
		setCliente (e) {
			this.filtro.ClienteID = e.datos.ID
			this.ClienteNombre = e.datos.cliente
			this.getFicheros()
		},
		delCliente () {
			this.filtro.ClienteID = null
		},
		seleccionar () {
			this.$emit('seleccionar', this.seleccionado.map(s => {
				return {
					FicheroID: s.FicheroID,
					Descripcion: s.Nombre,
					Duracion: s.FicheroDuracion
				}
			}))
			this.cerrar()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>

.contenedor {
	display: flex;
	flex-direction: row;
	width: 100%;
}

.formulario {
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 200px;
	width: 200px;
	border-right: 1px solid #e0e0e0;
	box-shadow: 2px 0px 2px rgba(0,0,0,0.1);
	background-color: #f0f0f0;
}

.listado {
	flex-grow: 1;
	flex-shrink: 1;
}

.nombreFichero {
	position: relative;
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	user-select: none;
	cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/utilidades/modalSeleccionOriginal.component.vue